import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import {select, Store} from '@ngrx/store';
import { FieldDefinition } from '@shared/models/field-definition';
import { PageInfo } from '@shared/models/page-info';
import { PagedResponseRow } from '@shared/models/paged-response-model';
import {TransactionState} from '../../store/reducers/transaction.reducer';
import {GetTransactionFieldDefinationsAction, GetTransactionsAction} from '../../store/actions/transaction.actions';
import {
  getTransactionFieldDefinitions, getTransactions,
  getTransactionsPageInfo
} from '../../store/selectors/transaction.selectors';
import {getFiledDefinitionsQuery} from '../../../queries/footprint-queries';
import {SmartGridService} from "@core/services/smart-grid.service";
import {GetCheckSumAction} from '@shared/store/actions/particle.actions';
@Component({
    standalone: false,
    selector   : 'lib-app-transaction-overview',
  templateUrl: './transaction-overview.component.html',
  styleUrls  : ['./transaction-overview.component.scss']
})
export class TransactionOverviewComponent implements OnInit {
  fieldDefinitions$: Observable<FieldDefinition[]>;
  private _fieldDefinitions: FieldDefinition[] = null;
  items$: Observable<PagedResponseRow[]>;
  pageInfo$: Observable<PageInfo>;
  @Output() rowSelected: EventEmitter<any> = new EventEmitter();
  sourceType: string = "Transaction";
  constructor (private store: Store<TransactionState>,
               private smartGridService: SmartGridService) { }

  ngOnInit () {
    //this.smartGridService.initDataProvider(this.sourceType);
    /*if (!this._fieldDefinitions) {
      this.store.dispatch(new GetTransactionFieldDefinationsAction('FootprintApi', getFiledDefinitionsQuery('Transaction', 'CR')));
    }
    this.store.dispatch(new GetTransactionsAction());

    this.fieldDefinitions$ = this.store.pipe(select(getTransactionFieldDefinitions));
    this.fieldDefinitions$.subscribe(fd => {
      this._fieldDefinitions = fd;
    });
    this.items$ = this.store.select(getTransactions);
    this.pageInfo$ = this.store.select(getTransactionsPageInfo);*/
  }

  onPageChange (event: PageInfo) {
    this.store.dispatch(new GetTransactionsAction(event.pageNo, event.pageSize));
  }

  rowClicked (event: any) {
    this.rowSelected.emit(event);
  }
}
